"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_OAUTH_LISTENER = void 0;
exports.ADD_OAUTH_LISTENER = Symbol('oauth-listener');
